import React from 'react';
import PropTypes from 'prop-types';

export function withSmartDataId(smartId) {
  return function wrapComponent(WrappedComponent) {
    const displayName =
      WrappedComponent.displayName || WrappedComponent.name || 'Component';

    const SmartDataComponent = React.forwardRef((props, ref) => {
      return React.createElement(
        'div',
        { 'data-smart-id': smartId, style: { display: 'contents' } },
        React.createElement(WrappedComponent, { ...props, ref })
      );
    });

    SmartDataComponent.displayName = `withSmartDataId(${displayName})`;
    return SmartDataComponent;
  };
}

export function smartDataId(smartId) {
  return { 'data-smart-id': smartId };
}

export const DataId = ({ smartId, children, as: Tag = 'div', ...props }) => {
  return React.createElement(
    Tag,
    { ...props, 'data-smart-id': smartId },
    children
  );
};

DataId.propTypes = {
  smartId: PropTypes.string.isRequired,
  children: PropTypes.node,
  as: PropTypes.elementType,
};
